import { render, staticRenderFns } from "./NotificationControl.vue?vue&type=template&id=eaa44678"
import script from "./NotificationControl.vue?vue&type=script&lang=js"
export * from "./NotificationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports